import { Box, Typography, Paper, Stack, Chip } from "@mui/material";
import { LitigationStage } from "./Areas";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { MatterCard } from "./MatterCard";
import { Badge } from "reactstrap";

interface Props {
  stage: LitigationStage;
  matters: LitigationFunnelMatter[];
}

export const Stage = ({ stage, matters }: Props) => {
  return (
    <Box
      sx={{
        width: 250,
        minWidth: 250,
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 1,
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="subtitle2" sx={{ wordBreak: 'break-word', textWrap: 'auto', flexShrink: 0, height: '45px' }}>
        {stage.name}
        <Chip label={matters.length} sx={{height: '20px', ml: 1}}/>
      </Typography>

      <Box sx={{ 
        flex: 1, 
        overflowY: "auto",
        mb: 2,
      }}>
        {matters.length > 0 ? (
          matters.map((matter, idx) => (
            <Box key={idx} sx={{ flexShrink: 0, padding: 0 }}>
              <MatterCard matter={matter} />
            </Box>
          ))
        ) : (
          <Typography
            variant="caption"
            sx={{ 
              textAlign: "center", 
              marginTop: 10, 
              flexShrink: 0 
            }}
          >
            No Case
          </Typography>
        )}
      </Box>
    </Box>
  );
};
